<template>
    <div class="public_container user_department_wrap" v-loading="loading">
        <div class="returnNavBar">
            <ReturnNavBar
                title="返回"
                :isTitleNormal="true"
                :isAllFunctions="true"
                :isCustomReturnEvent="true"
                @returnEvent="handleReturnEvent"
            ></ReturnNavBar>
        </div>
        <div class="title_wrap">
            <span
                v-if="
                    selectType == 'departmentUserPost' ||
                    selectType == 'departmentUser' ||
                    selectType == 'departmentUserTag'
                "
                @click="handleClickTab('department')"
                :class="type == 'department' ? 'active' : ''"
                >部门</span
            >
            <span @click="handleClickTab('user')" :class="type == 'user' ? 'active' : ''">人员</span>
        </div>
        <template v-if="type == 'post'">
            <div class="check_box_block">
                <el-checkbox-group @change="handleChangePost" v-model="post_selected_ids">
                    <el-checkbox :key="item.relate_id" :label="item.relate_id" v-for="item in postList">
                        {{ item.relate_name }}
                    </el-checkbox>
                </el-checkbox-group>
            </div>
        </template>
        <template v-else-if="type == 'tag'">
            <div style="padding: 0 15px 10px">
                <el-input
                    @keyup.enter.native="getDepartmentAndUserList"
                    placeholder="请输入"
                    size="small"
                    v-model="keyWord"
                    clearable
                    @blur="getDepartmentAndUserList"
                    @clear="getDepartmentAndUserList"
                >
                    <i @click="getDepartmentAndUserList" class="el-icon-search" slot="suffix"></i>
                </el-input>
            </div>
            <div class="check_box_block">
                <el-checkbox-group v-model="tag_selected_ids">
                    <el-checkbox
                        @change="handleChangeTag($event, item)"
                        :key="item.relate_id"
                        :label="item.relate_id"
                        v-for="item in userTagList"
                    >
                        <span>{{ item.relate_name }}</span
                        ><span> ({{ item.users.length }}人)</span>
                    </el-checkbox>
                </el-checkbox-group>
            </div>
        </template>
        <template v-else>
            <div>
                <van-search
                    v-model="keyWord"
                    shape="round"
                    placeholder="请输入"
                    @search="getDepartmentAndUserList"
                    @clear="getDepartmentAndUserList"
                >
                    <template #left-icon> </template>
                    <template #right-icon>
                        <i class="iconfont icon-sousuo" @click="getDepartmentAndUserList"></i>
                    </template>
                </van-search>
            </div>
            <div class="selected_wrap" v-if="department_selected_list.length || user_selected_list.length || tag_selected_list.length">
                <div>
                    <span
                        v-if="department_selected_list.length"
                        v-text="department_selected_list.length + '个部门'"
                    ></span>
                    <span
                        v-if="user_selected_list.length"
                        v-text="user_selected_list.length + '个人员'"
                    ></span>
                    <span
                        v-if="type == 'tag' && tag_selected_list.length"
                        v-text="tag_selected_list.length + '个标签'"
                    ></span>
                </div>
                <span class="delete_selected" @click="handleClickClearAllSelected">清除</span>
            </div>
            <div class="mobile_container scroll_wrap">
                <el-tree
                    :data="selectable_list"
                    :default-expand-all="true"
                    :default-expanded-keys="default_expanded"
                    :expand-on-click-node="false"
                    :props="defaultProps"
                    @check="handleCheckNodeItem"
                    check-on-click-node
                    :check-strictly="localCheckStrictly"
                    node-key="relate_type_id"
                    ref="dep_and_user_tree"
                    show-checkbox
                >
                </el-tree>
            </div>
            <div class="mobile_footer_btn">
                <van-button color="rgba(25, 144, 255, 1)" @click="handleClickConfirm">确认</van-button>
            </div>
        </template>
    </div>
</template>
<script>
import { GetDepartmentUserList, GetDepartmentList, PersonTagList } from "@/api/index.js";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
export default {
    name: "userDepartmentPostSelection",
    components: { ReturnNavBar },
    data() {
        return {
            loading: false,
            selectType: "departmentUserPost", // // departmentUserPost =  部门人员岗位  departmentUser == 部门人员 user == 人员 departmentUserTag == 部门 人员 人员标签
            localCheckStrictly: true,
            BtnDisabled: false,
            selectable_list: [],
            default_expanded: [],
            defaultProps: {
                children: "children",
                label: "relate_name",
            },
            keyWord: "",
            type: "department",
            postList: [
                { relate_id: 1, relate_name: "直属上级", relate_type: "3", relate_type_id: "1_3" },
                { relate_id: 2, relate_name: "部门负责人", relate_type: "3", relate_type_id: "2_3" },
                { relate_id: 3, relate_name: "普通员工", relate_type: "3", relate_type_id: "3_3" },
            ],
            userTagList: [],
            post_selected_ids: [],
            department_selected_list: [],
            user_selected_list: [],
            post_selected_list: [],

            tag_selected_ids: [],
            tag_selected_list: [],
        };
    },
    created() {
        if (this.selectType == "user") {
            this.type = "user";
            this.localCheckStrictly = false;
        }
        this.getDepartmentAndUserList();
    },
    methods: {
        handleReturnEvent() {
            this.$emit("popupClose");
        },
        handleClickTab(type) {
            this.type = type;
            if (type == "user") {
                this.localCheckStrictly = false;
            } else {
                this.localCheckStrictly = true;
            }
            this.getDepartmentAndUserList();
        },
        getDepartmentAndUserList() {
            if (this.type == "department") {
                GetDepartmentList({ keyword: this.keyWord }).then((res) => {
                    if (res.code === 200) {
                        this.selectable_list = res.data || [];
                        this.recursionAddRelateType(this.selectable_list);
                        this.$nextTick(() => {
                            this.department_selected_list.forEach((item) => {
                                this.$refs.dep_and_user_tree.setChecked(item.relate_type_id, true);
                            });
                        });
                    }
                });
            } else if (this.type == "user") {
                GetDepartmentUserList({ name: this.keyWord }).then((res) => {
                    if (res.code === 200) {
                        this.selectable_list = res.data || [];
                        this.recursionAddRelateType(this.selectable_list);
                        this.$nextTick(() => {
                            this.user_selected_list.forEach((item) => {
                                this.$refs.dep_and_user_tree.setChecked(item.relate_type_id, true);
                            });
                        });
                    }
                });
            } else if (this.type == "tag") {
                PersonTagList({ keyword: this.keyWord, page: 1, pageSize: 1000 }).then((res) => {
                    if (res.code === 200) {
                        let data = res.data.data || [];
                        data.forEach((item) => {
                            this.$set(item, "relate_id", item.id);
                            this.$set(item, "relate_name", item.name);
                            this.$set(item, "relate_type", "App\\Models\\UserTagRelate");
                            this.$set(item, "relate_type_id", item.relate_id + "_" + item.relate_type);
                        });
                        this.userTagList = data;
                    }
                });
            }
        },
        recursionAddRelateType(arr) {
            arr.forEach((item) => {
                item.relate_type_id = item.relate_id + "_" + item.relate_type;
                if (item.children && item.children.length > 0) {
                    this.recursionAddRelateType(item.children);
                }
            });
        },
        handleCheckNodeItem(data, { checkedKeys, checkedNodes }) {
            const dataIndex = checkedKeys.findIndex((check) => check === data.relate_type_id);
            if (dataIndex > -1) {
                let json = {
                    relate_type_id: data.relate_type_id,
                    relate_id: data.relate_id,
                    relate_name: data.relate_name,
                    relate_type: data.relate_type,
                };
                if (this.type == "department") {
                    this.department_selected_list.push(json);
                } else if (this.type == "user") {
                    const arr = this.findItemsWithType1(data);
                    arr.forEach((item) => {
                        if (
                            item.relate_type != "App\\Models\\Department" &&
                            this.user_selected_list.findIndex((user) => user.relate_type_id === item.relate_type_id) < 0
                        ) {
                            this.user_selected_list.push({
                                relate_type_id: item.relate_type_id,
                                relate_id: item.relate_id,
                                relate_name: item.relate_name,
                                relate_type: item.relate_type,
                            });
                        }
                        this.$refs.dep_and_user_tree.setChecked(item.relate_type_id, true);
                    });
                }
            } else {
                if (this.type == "department") {
                    this.department_selected_list.splice(
                        this.department_selected_list.findIndex((item) => item.relate_type_id === data.relate_type_id),
                        1
                    );
                } else if (this.type == "user") {
                    const arr = this.findItemsWithType1(data);
                    arr.forEach((item) => {
                        if (
                            item.relate_type != "App\\Models\\Department" &&
                            this.user_selected_list.findIndex((user) => user.relate_type_id === item.relate_type_id) >
                                -1
                        ) {
                            this.user_selected_list.splice(
                                this.user_selected_list.findIndex(
                                    (user) => user.relate_type_id === item.relate_type_id
                                ),
                                1
                            );
                        }
                        this.$refs.dep_and_user_tree.setChecked(item.relate_type_id, false);
                    });
                }
            }
        },

        findItemsWithType1(obj) {
            let result = [];
            // 递归函数
            function traverse(obj) {
                result.push(obj);
                if (Array.isArray(obj.children)) {
                    obj.children.forEach((child) => {
                        traverse(child);
                    });
                }
            }
            traverse(obj);
            return result;
        },

        handleClickDelSelected(item, index) {
            if (this.type == "department") {
                this.department_selected_list.splice(index, 1);
                this.$refs.dep_and_user_tree.setChecked(item.relate_type_id, false);
            } else if (this.type == "user") {
                this.user_selected_list.splice(index, 1);
                this.$refs.dep_and_user_tree.setChecked(item.relate_type_id, false);
            } else if (this.type == "post") {
                this.post_selected_list.splice(index, 1);
                this.post_selected_ids = this.post_selected_list.map((map) => map.relate_id);
            } else if (this.type == "tag") {
                this.tag_selected_list.splice(index, 1);
                this.tag_selected_ids = this.tag_selected_list.map((map) => map.relate_id);
            }
        },
        // 选择岗位
        handleChangePost(value) {
            this.post_selected_list = [];
            this.postList.forEach((item) => {
                if (value.indexOf(item.relate_id) > -1) {
                    this.post_selected_list.push(item);
                }
            });
        },
        // 选择人员标签
        handleChangeTag(value, row) {
            if (value) {
                let json = {
                    relate_type_id: row.relate_type_id,
                    relate_id: row.relate_id,
                    relate_name: row.relate_name,
                    relate_type: row.relate_type,
                };
                this.tag_selected_list.push(json);
            } else {
                let index = this.tag_selected_list.findIndex((find) => find.relate_id == value);
                this.tag_selected_list.splice(index, 1);
            }
        },
        // 清空所有的选中数据
        handleClickClearAllSelected() {
            this.department_selected_list = []
            this.user_selected_list = []
            this.$refs.dep_and_user_tree.setCurrentKey(null)
        },
        handleClickConfirm() {
            let selected_list = [
                ...this.department_selected_list,
                ...this.user_selected_list,
                ...this.post_selected_list,
                ...this.tag_selected_list,
            ];
            this.$emit("success", selected_list);
        },
    },
};
</script>
<style lang="scss" scoped>
.user_department_wrap {
    .title_wrap {
        height: 44px;
        font-size: 16px;
        color: #333333;
        padding: 0 16px;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #f3f3f3;
        border-top: 1px solid #f3f3f3;
        & > span {
            padding: 0 16px;
            display: block;
            height: 44px;
            line-height: 44px;
            cursor: pointer;
            position: relative;
            &.active {
                color: rgba(25, 144, 255, 1);
                border-bottom: 2px solid rgba(25, 144, 255, 1);
            }
        }
    }
    .selected_wrap {
        padding: 0 16px;
        height: 42px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: rgba(247, 248, 250, 1);
        font-size: 14px;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 22px;
        & > div {
            span {
                color: rgba(102, 102, 102, 1);
            }
        }
        .delete_selected {
            color: rgba(255, 77, 79, 1);
        }
    }
    .mobile_container {
        padding: 0 10px;
        background-color: #ffffff;
    }
    .mobile_footer_btn {
        padding: 10px 16px;
        .van-button {
            width: 100%;
            height: 38px;
            border-radius: 8px;
        }
    }
}
</style>
